import { useState, useMemo } from 'react';
import mammoth from 'mammoth';
import { urlAssinadaRoteiro, marcarEventoRoteiro } from '../../lib/portal';
import PortalPerfilMarca from './PortalPerfilMarca';

const PLATAFORMAS = {
  'Instagram': { cor: '#D4789B', icone: '📷' },
  'TikTok':    { cor: '#1a1a1a', icone: '🎵' },
  'YouTube':   { cor: '#E05454', icone: '▶️' },
  'LinkedIn':  { cor: '#4A90D9', icone: '💼' },
  'Facebook':  { cor: '#3b5998', icone: '👍' },
  'Outro':     { cor: '#9B7FD4', icone: '✨' },
};

function fmtData(d) {
  return d ? new Date(d + 'T00:00').toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' }) : '—';
}
function fmtDataHora(iso) {
  return iso ? new Date(iso).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '';
}
function temEvento(item, etapa) { return item.eventos?.some(e => e.etapa === etapa); }
function dataEvento(item, etapa) { return item.eventos?.find(e => e.etapa === etapa)?.criado_em; }

// Criativo: cliente escolhe até 10/mês pra gravar. Carrossel/Post/Reels
// no Instagram: cliente escolhe até 2/semana (a Vuli quem produz).
const LIMITE_CRIATIVOS_MES = 10;
const LIMITE_INSTAGRAM_SEMANA = 2;
function grupoQuota(item) {
  if (item.formato === 'Criativo') return 'mes';
  if (['Carrossel', 'Post', 'Reels'].includes(item.formato) && item.plataforma === 'Instagram') return 'semana';
  return null;
}
function inicioMes() { const d = new Date(); d.setDate(1); d.setHours(0, 0, 0, 0); return d; }
function inicioSemana() { const d = new Date(); d.setDate(d.getDate() - d.getDay()); d.setHours(0, 0, 0, 0); return d; }

function RoteiroCard({ item, arquivoLote, token, onEventoAlterado, escolha, troca }) {
  const [aberto, setAberto] = useState(false);
  const [html, setHtml] = useState(null);
  const [carregandoHtml, setCarregandoHtml] = useState(false);
  const [salvandoEtapa, setSalvandoEtapa] = useState(null);
  const [recusando, setRecusando] = useState(false);
  const [motivoRecusa, setMotivoRecusa] = useState('');
  const [trocando, setTrocando] = useState(false);
  const [novoEscolhidoId, setNovoEscolhidoId] = useState('');
  const plat = PLATAFORMAS[item.plataforma] || PLATAFORMAS.Outro;
  const gravado = temEvento(item, 'gravado');
  const enviado = temEvento(item, 'enviado_edicao');
  const recusado = temEvento(item, 'recusado');
  const arquivo = item.roteiro_arquivo || arquivoLote;

  async function confirmarTroca() {
    if (!novoEscolhidoId) return;
    await troca.onTrocar(novoEscolhidoId);
    setTrocando(false);
    setNovoEscolhidoId('');
  }

  async function abrir() {
    setAberto(a => !a);
    if (html || !arquivo) return;
    setCarregandoHtml(true);
    try {
      const url = await urlAssinadaRoteiro(arquivo);
      const resp = await fetch(url);
      const arrayBuffer = await resp.arrayBuffer();
      const resultado = await mammoth.convertToHtml({ arrayBuffer });
      setHtml(resultado.value);
    } catch (e) { /* fica só com o botão de baixar */ }
    setCarregandoHtml(false);
  }

  const temRoteiroTexto = !!(item.roteiro || '').trim();
  const podeAbrir = !!arquivo || temRoteiroTexto;

  async function baixar() {
    const url = await urlAssinadaRoteiro(arquivo);
    window.open(url, '_blank');
  }

  async function toggleEtapa(etapa, valorAtual, detalhe) {
    setSalvandoEtapa(etapa);
    try {
      await marcarEventoRoteiro(token, item.id, etapa, !valorAtual, detalhe);
      onEventoAlterado(item.id, etapa, !valorAtual, detalhe);
    } catch (e) {
      alert('Não consegui salvar: ' + e.message);
    }
    setSalvandoEtapa(null);
  }

  async function confirmarRecusa() {
    await toggleEtapa('recusado', false, motivoRecusa.trim() || null);
    setRecusando(false);
    setMotivoRecusa('');
  }

  return (
    <div className="card" style={{ padding: 16, marginBottom: 10, borderLeft: `4px solid ${recusado ? 'var(--gray-300)' : plat.cor}`, opacity: recusado ? 0.65 : 1 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
        {item.data && (
          <div style={{ background: 'var(--purple)', color: 'white', borderRadius: 8, padding: '4px 10px', textAlign: 'center', flexShrink: 0 }}>
            <div style={{ fontSize: 15, fontWeight: 800, lineHeight: 1.1 }}>{new Date(item.data + 'T00:00').getDate()}</div>
            <div style={{ fontSize: 9, textTransform: 'uppercase' }}>{new Date(item.data + 'T00:00').toLocaleDateString('pt-BR', { month: 'short' }).replace('.', '')}</div>
          </div>
        )}
        <div style={{ cursor: podeAbrir ? 'pointer' : 'default', flex: 1, minWidth: 200 }} onClick={podeAbrir ? abrir : undefined}>
          <div style={{ fontWeight: 700, fontSize: 14, color: 'var(--text-primary)' }}>{plat.icone} {item.titulo}</div>
          <div style={{ fontSize: 11, color: 'var(--text-secondary)', marginTop: 2, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            <span>{item.formato}</span>
            {item.pilar && <span style={{ background: '#F3EBFF', color: 'var(--purple-rich)', padding: '1px 8px', borderRadius: 10, fontWeight: 600 }}>{item.pilar}</span>}
            {item.objetivo && <span style={{ background: 'var(--bg-secondary)', padding: '1px 8px', borderRadius: 10 }}>{item.objetivo}</span>}
            {item.subnicho && <span style={{ background: 'var(--bg-secondary)', padding: '1px 8px', borderRadius: 10 }}>{item.subnicho}</span>}
            {!item.data && item.escolhido_em && <span style={{ color: 'var(--purple-rich)', fontWeight: 600 }}>escolhido, aguardando data</span>}
            {!podeAbrir && <span style={{ color: '#dc2626', fontWeight: 600 }}>⚠ sem roteiro ainda</span>}
          </div>
        </div>
        {podeAbrir && <span style={{ color: 'var(--purple)', fontSize: 13 }}>{aberto ? '▲' : '▼ ver roteiro'}</span>}
      </div>

      {recusado ? (
        <div style={{ marginTop: 12, padding: '8px 12px', background: 'var(--bg-secondary)', borderRadius: 8 }}>
          <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--gray-500)' }}>🚫 Você marcou que não vai gravar esse{dataEvento(item, 'recusado') ? ` (${fmtDataHora(dataEvento(item, 'recusado'))})` : ''}</div>
          {item.eventos?.find(e => e.etapa === 'recusado')?.detalhe && (
            <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 4 }}>Motivo: {item.eventos.find(e => e.etapa === 'recusado').detalhe}</div>
          )}
          <button onClick={() => toggleEtapa('recusado', true)} disabled={salvandoEtapa === 'recusado'}
            style={{ marginTop: 8, background: 'transparent', border: '1px solid var(--border)', borderRadius: 6, padding: '4px 10px', fontSize: 11.5, color: 'var(--text-secondary)', cursor: 'pointer' }}>
            ↩ Desfazer, vou gravar afinal
          </button>
        </div>
      ) : escolha?.grupo && !item.escolhido_em ? (
        <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          <button onClick={() => escolha.onEscolher(true)} disabled={!escolha.podeEscolher || escolha.escolhendo}
            style={{ background: escolha.podeEscolher ? 'var(--purple)' : 'var(--gray-300)', color: 'white', border: 'none', borderRadius: 6, padding: '7px 16px', fontSize: 12, fontWeight: 700, cursor: escolha.podeEscolher ? 'pointer' : 'not-allowed' }}>
            {escolha.escolhendo ? 'Escolhendo...' : '✓ Quero esse'}
          </button>
          <span style={{ fontSize: 11.5, color: escolha.podeEscolher ? 'var(--text-secondary)' : '#dc2626', fontWeight: escolha.podeEscolher ? 400 : 600 }}>
            {escolha.podeEscolher ? escolha.quotaTexto : `Limite atingido — ${escolha.quotaTexto}`}
          </span>
        </div>
      ) : escolha?.grupo && item.escolhido_em && !item.requer_gravacao_cliente ? (
        <div style={{ marginTop: 12, padding: '8px 12px', background: '#dcfce7', borderRadius: 8, fontSize: 12.5, color: '#16a34a', fontWeight: 600, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <span>✓ Você escolheu esse — nossa equipe vai produzir</span>
          <button onClick={() => escolha.onEscolher(false)} disabled={escolha.escolhendo}
            style={{ background: 'transparent', border: '1px solid rgba(22,163,74,0.3)', borderRadius: 6, padding: '4px 10px', fontSize: 11, color: '#16a34a', cursor: 'pointer' }}>
            ↩ Desmarcar
          </button>
        </div>
      ) : (
        <>
          <div style={{ display: 'flex', gap: 16, marginTop: 12, flexWrap: 'wrap', alignItems: 'center' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: salvandoEtapa ? 'wait' : 'pointer', fontSize: 12.5 }}>
              <input type="checkbox" checked={gravado} disabled={salvandoEtapa === 'gravado'} onChange={() => toggleEtapa('gravado', gravado)} />
              🎥 Gravei {gravado && <span style={{ color: 'var(--gray-400)', fontSize: 10.5 }}>({fmtDataHora(dataEvento(item, 'gravado'))})</span>}
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: (!gravado || salvandoEtapa) ? 'not-allowed' : 'pointer', fontSize: 12.5, opacity: gravado ? 1 : 0.5 }}>
              <input type="checkbox" checked={enviado} disabled={!gravado || salvandoEtapa === 'enviado_edicao'} onChange={() => toggleEtapa('enviado_edicao', enviado)} />
              📤 Enviei pra edição {enviado && <span style={{ color: 'var(--gray-400)', fontSize: 10.5 }}>({fmtDataHora(dataEvento(item, 'enviado_edicao'))})</span>}
            </label>
            {!recusando && (
              <button onClick={() => setRecusando(true)} style={{ background: 'transparent', border: 'none', color: 'var(--gray-400)', fontSize: 11.5, cursor: 'pointer', textDecoration: 'underline' }}>
                não vou gravar esse
              </button>
            )}
            {troca && !trocando && (
              <button onClick={() => setTrocando(true)} style={{ background: 'transparent', border: 'none', color: 'var(--purple-rich)', fontSize: 11.5, cursor: 'pointer', textDecoration: 'underline' }}>
                🔄 trocar por outro do acervo
              </button>
            )}
          </div>
          {recusando && (
            <div style={{ marginTop: 10, padding: '10px 12px', background: 'var(--bg-secondary)', borderRadius: 8 }}>
              <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 6 }}>Quer dizer por quê? (opcional)</div>
              <textarea value={motivoRecusa} onChange={e => setMotivoRecusa(e.target.value)} rows={2}
                placeholder="Ex: não me identifico com esse tema..."
                style={{ width: '100%', padding: '8px 10px', border: '1px solid var(--border)', borderRadius: 6, fontSize: 12.5, boxSizing: 'border-box', resize: 'vertical' }} />
              <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                <button onClick={confirmarRecusa} disabled={salvandoEtapa === 'recusado'}
                  style={{ background: 'var(--purple)', color: 'white', border: 'none', borderRadius: 6, padding: '6px 14px', fontSize: 12, cursor: 'pointer', fontWeight: 600 }}>
                  Confirmar
                </button>
                <button onClick={() => { setRecusando(false); setMotivoRecusa(''); }}
                  style={{ background: 'transparent', border: '1px solid var(--border)', borderRadius: 6, padding: '6px 14px', fontSize: 12, cursor: 'pointer', color: 'var(--text-secondary)' }}>
                  Cancelar
                </button>
              </div>
            </div>
          )}
          {trocando && troca && (
            <div style={{ marginTop: 10, padding: '10px 12px', background: 'var(--bg-secondary)', borderRadius: 8 }}>
              {troca.disponiveis.length === 0 ? (
                <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Não tem outro vídeo de TikTok disponível no acervo agora.</div>
              ) : (
                <>
                  <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 6 }}>Qual você quer gravar no lugar desse?</div>
                  <select value={novoEscolhidoId} onChange={e => setNovoEscolhidoId(e.target.value)}
                    style={{ width: '100%', padding: '7px 10px', border: '1px solid var(--border)', borderRadius: 6, fontSize: 12.5, marginBottom: 8 }}>
                    <option value=''>Escolher...</option>
                    {troca.disponiveis.map(d => <option key={d.id} value={d.id}>{d.titulo}</option>)}
                  </select>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button onClick={confirmarTroca} disabled={!novoEscolhidoId || troca.trocando}
                      style={{ background: 'var(--purple)', color: 'white', border: 'none', borderRadius: 6, padding: '6px 14px', fontSize: 12, cursor: 'pointer', fontWeight: 600 }}>
                      {troca.trocando ? 'Trocando...' : 'Confirmar troca'}
                    </button>
                    <button onClick={() => { setTrocando(false); setNovoEscolhidoId(''); }}
                      style={{ background: 'transparent', border: '1px solid var(--border)', borderRadius: 6, padding: '6px 14px', fontSize: 12, cursor: 'pointer', color: 'var(--text-secondary)' }}>
                      Cancelar
                    </button>
                  </div>
                </>
              )}
            </div>
          )}
        </>
      )}

      {aberto && (
        <div style={{ marginTop: 14, paddingTop: 14, borderTop: '1px solid rgba(107,33,168,0.08)' }}>
          {carregandoHtml && <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Abrindo roteiro...</div>}
          {html && <div className="portal-roteiro-html" dangerouslySetInnerHTML={{ __html: html }} />}
          {!arquivo && temRoteiroTexto && (
            <div>
              {item.gancho && (
                <div style={{ marginBottom: 12 }}>
                  <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--purple-rich)', textTransform: 'uppercase', marginBottom: 3 }}>🎣 Gancho</div>
                  <div style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--text-primary)', whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>{item.gancho}</div>
                </div>
              )}
              <div style={{ marginBottom: item.legenda ? 12 : 0 }}>
                {item.gancho && <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--gray-400)', textTransform: 'uppercase', marginBottom: 3 }}>Roteiro</div>}
                <div style={{ fontSize: 13, color: 'var(--text-primary)', whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>{item.roteiro}</div>
              </div>
              {item.legenda && (
                <div>
                  <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--gray-400)', textTransform: 'uppercase', marginBottom: 3 }}>📝 Legenda</div>
                  <div style={{ fontSize: 13, color: 'var(--text-secondary)', whiteSpace: 'pre-wrap', lineHeight: 1.6, background: 'var(--bg-secondary)', padding: '8px 12px', borderRadius: 8 }}>{item.legenda}</div>
                </div>
              )}
            </div>
          )}
          {arquivo && (
            <button onClick={baixar} style={{ marginTop: 10, background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 8, padding: '6px 14px', fontSize: 12, color: 'var(--purple-rich)', cursor: 'pointer', fontWeight: 600 }}>
              ⬇ Baixar .docx
            </button>
          )}
        </div>
      )}
    </div>
  );
}

const NOMES_MES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
const NOMES_DIA_SEMANA = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

function ItemCalendario({ item, hojeStr, onAbrir }) {
  const plat = PLATAFORMAS[item.plataforma] || PLATAFORMAS.Outro;
  const atrasado = !item.concluido && item.data < hojeStr;
  return (
    <div onClick={() => onAbrir(item)} title={item.titulo} style={{ background: 'white', borderRadius: 6, padding: '4px 6px', marginBottom: 3, fontSize: 10, borderLeft: `2px solid ${plat.cor}`, cursor: 'pointer' }}>
      <div style={{ fontWeight: 700, color: 'var(--text-primary)', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', lineHeight: 1.25 }}>{plat.icone} {item.titulo}</div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 2 }}>
        <span style={{ fontSize: 9, color: 'var(--gray-400)' }}>{item.formato}</span>
        <span style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
          <span style={{ fontSize: 9 }}>{item.requer_gravacao_cliente ? '🎥' : '🏢'}</span>
          {item.concluido ? <span style={{ color: '#16a34a' }}>✓</span> : (atrasado && <span style={{ color: '#dc2626' }}>⚠</span>)}
        </span>
      </div>
    </div>
  );
}

function DetalheModal({ item, onFechar }) {
  const plat = PLATAFORMAS[item.plataforma] || PLATAFORMAS.Outro;
  return (
    <div onClick={onFechar} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1200, padding: 16 }}>
      <div onClick={e => e.stopPropagation()} className="card" style={{ width: 460, maxHeight: '85vh', overflowY: 'auto', padding: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10, gap: 10 }}>
          <div style={{ fontWeight: 700, fontSize: 16, color: 'var(--text-primary)' }}>{plat.icone} {item.titulo}</div>
          <button onClick={onFechar} style={{ background: 'transparent', border: 'none', fontSize: 20, cursor: 'pointer', color: 'var(--gray-400)', flexShrink: 0 }}>×</button>
        </div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 12, fontSize: 12, color: 'var(--text-secondary)' }}>
          <span style={{ background: 'var(--bg-secondary)', padding: '2px 10px', borderRadius: 12 }}>{item.formato}</span>
          <span style={{ background: 'var(--bg-secondary)', padding: '2px 10px', borderRadius: 12 }}>{item.plataforma}</span>
          {item.pilar && <span style={{ background: '#F3EBFF', color: 'var(--purple-rich)', padding: '2px 10px', borderRadius: 12, fontWeight: 600 }}>{item.pilar}</span>}
          {item.objetivo && <span style={{ background: 'var(--bg-secondary)', padding: '2px 10px', borderRadius: 12 }}>{item.objetivo}</span>}
          {item.subnicho && <span style={{ background: 'var(--bg-secondary)', padding: '2px 10px', borderRadius: 12 }}>{item.subnicho}</span>}
        </div>
        <div style={{ fontSize: 13, marginBottom: 6 }}><strong>Vai ao ar em:</strong> {fmtData(item.data)}</div>
        <div style={{ fontSize: 13, marginBottom: 6 }}><strong>Status:</strong> {item.status}</div>
        <div style={{ fontSize: 13, marginBottom: 12 }}>
          <strong>Responsável:</strong> {item.requer_gravacao_cliente ? '🎥 você grava' : '🏢 a gente cuida disso'}
        </div>
        {item.concluido && <div style={{ fontSize: 13, color: '#16a34a', fontWeight: 600, marginBottom: 12 }}>✓ Já publicado</div>}

        {(item.gancho || item.roteiro || item.legenda) && (
          <div style={{ borderTop: '1px solid rgba(107,33,168,0.08)', paddingTop: 12 }}>
            {item.gancho && (
              <div style={{ marginBottom: 10 }}>
                <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--purple-rich)', textTransform: 'uppercase', marginBottom: 3 }}>🎣 Gancho</div>
                <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>{item.gancho}</div>
              </div>
            )}
            {item.roteiro && (
              <div style={{ marginBottom: item.legenda ? 10 : 0 }}>
                {item.gancho && <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--gray-400)', textTransform: 'uppercase', marginBottom: 3 }}>Roteiro</div>}
                <div style={{ fontSize: 13, color: 'var(--text-primary)', whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>{item.roteiro}</div>
              </div>
            )}
            {item.legenda && (
              <div>
                <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--gray-400)', textTransform: 'uppercase', marginBottom: 3 }}>📝 Legenda</div>
                <div style={{ fontSize: 13, color: 'var(--text-secondary)', whiteSpace: 'pre-wrap', lineHeight: 1.6, background: 'var(--bg-secondary)', padding: '8px 12px', borderRadius: 8 }}>{item.legenda}</div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function CalendarioPublicacao({ conteudos }) {
  const [dataRef, setDataRef] = useState(new Date());
  const [visao, setVisao] = useState('mes');
  const [itemDetalhe, setItemDetalhe] = useState(null);
  const hojeStr = new Date().toISOString().split('T')[0];

  function doDia(dataStr) { return conteudos.filter(c => c.data === dataStr); }
  function navegar(delta) {
    const d = new Date(dataRef);
    if (visao === 'mes') d.setMonth(d.getMonth() + delta);
    else d.setDate(d.getDate() + delta * 7);
    setDataRef(d);
  }

  const ano = dataRef.getFullYear(), mes = dataRef.getMonth();
  const primeiroDia = new Date(ano, mes, 1);
  const ultimoDia = new Date(ano, mes + 1, 0);
  const offsetMes = primeiroDia.getDay();
  const celulasMes = [...Array(offsetMes).fill(null), ...Array.from({ length: ultimoDia.getDate() }, (_, i) => i + 1)];

  const inicioSemanaRef = new Date(dataRef);
  inicioSemanaRef.setDate(inicioSemanaRef.getDate() - inicioSemanaRef.getDay());
  const diasSemana = Array.from({ length: 7 }, (_, i) => { const d = new Date(inicioSemanaRef); d.setDate(d.getDate() + i); return d; });

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 14, flexWrap: 'wrap' }}>
        <button onClick={() => navegar(-1)} style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 6, padding: '6px 12px', cursor: 'pointer' }}>←</button>
        <span style={{ fontWeight: 700, fontSize: 15, color: 'var(--text-primary)', textTransform: 'capitalize' }}>
          {visao === 'mes' ? `${NOMES_MES[mes]} ${ano}` : `Semana de ${diasSemana[0].toLocaleDateString('pt-BR')}`}
        </span>
        <button onClick={() => navegar(1)} style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 6, padding: '6px 12px', cursor: 'pointer' }}>→</button>
        <button onClick={() => setDataRef(new Date())} style={{ background: 'transparent', border: 'none', color: 'var(--purple)', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>Hoje</button>
        <div style={{ flex: 1 }} />
        <div className="tabs-wrap">
          <button onClick={() => setVisao('mes')} className={`tab-btn${visao === 'mes' ? ' active' : ''}`}>Mês</button>
          <button onClick={() => setVisao('semana')} className={`tab-btn${visao === 'semana' ? ' active' : ''}`}>Semana</button>
        </div>
      </div>

      {visao === 'mes' ? (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 6, marginBottom: 6 }}>
            {NOMES_DIA_SEMANA.map(d => <div key={d} style={{ textAlign: 'center', fontSize: 11, fontWeight: 700, color: 'var(--gray-400)' }}>{d}</div>)}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 6 }}>
            {celulasMes.map((dia, i) => {
              const dataStr = dia ? `${ano}-${String(mes + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}` : null;
              const itens = dataStr ? doDia(dataStr) : [];
              return (
                <div key={i} style={{ minHeight: 92, background: dia ? 'var(--bg-secondary)' : 'transparent', borderRadius: 8, padding: 6 }}>
                  {dia && (
                    <>
                      <div style={{ fontSize: 11, marginBottom: 4, fontWeight: dataStr === hojeStr ? 700 : 400, color: dataStr === hojeStr ? 'var(--purple)' : 'var(--gray-400)' }}>{dia}</div>
                      {itens.map(item => <ItemCalendario key={item.id} item={item} hojeStr={hojeStr} onAbrir={setItemDetalhe} />)}
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 8 }}>
          {diasSemana.map(d => {
            const dataStr = d.toISOString().split('T')[0];
            const itens = doDia(dataStr);
            return (
              <div key={dataStr} style={{ background: 'var(--bg-secondary)', borderRadius: 8, padding: 10, minHeight: 220 }}>
                <div style={{ fontSize: 11, fontWeight: 700, marginBottom: 8, color: dataStr === hojeStr ? 'var(--purple)' : 'var(--text-secondary)' }}>
                  {NOMES_DIA_SEMANA[d.getDay()]} {d.getDate()}
                </div>
                {itens.length === 0
                  ? <div style={{ fontSize: 10, color: 'var(--gray-300)', textAlign: 'center', marginTop: 20 }}>—</div>
                  : itens.map(item => <ItemCalendario key={item.id} item={item} hojeStr={hojeStr} onAbrir={setItemDetalhe} />)}
              </div>
            );
          })}
        </div>
      )}

      <div style={{ display: 'flex', gap: 16, marginTop: 14, fontSize: 11, color: 'var(--text-secondary)' }}>
        <span>🎥 você grava</span>
        <span>🏢 a gente cuida disso</span>
        <span style={{ color: '#16a34a' }}>✓ publicado</span>
        <span style={{ color: '#dc2626' }}>⚠ atrasado</span>
        <span>· clique num item pra ver detalhes</span>
      </div>

      {itemDetalhe && <DetalheModal item={itemDetalhe} onFechar={() => setItemDetalhe(null)} />}
    </div>
  );
}

function LoteBloco({ lote, itens, token, onEventoAlterado, escolhaPorItem }) {
  return (
    <div style={{ marginBottom: 26 }}>
      <div style={{ background: 'linear-gradient(120deg, var(--purple), var(--purple-rich))', borderRadius: 14, padding: '14px 18px', color: 'white', marginBottom: 14 }}>
        <div style={{ fontWeight: 700, fontSize: 15, fontFamily: 'Playfair Display, serif' }}>{lote.titulo}</div>
        {lote.explicacao && <div style={{ fontSize: 12.5, opacity: 0.9, marginTop: 6, whiteSpace: 'pre-wrap' }}>{lote.explicacao}</div>}
        {lote.link_drive_upload && (
          <a href={lote.link_drive_upload} target="_blank" rel="noreferrer"
            style={{ display: 'inline-block', marginTop: 10, background: 'rgba(255,255,255,0.15)', color: 'white', padding: '6px 14px', borderRadius: 20, fontSize: 12, fontWeight: 600, textDecoration: 'none' }}>
            📁 Subir gravação no Drive
          </a>
        )}
      </div>
      {itens.map(item => <RoteiroCard key={item.id} item={item} arquivoLote={lote.arquivo_unico} token={token} onEventoAlterado={onEventoAlterado} escolha={escolhaPorItem(item)} />)}
    </div>
  );
}

function ehTikTok(item) { return item.formato === 'Vídeo TikTok' && item.plataforma === 'TikTok'; }
function estaComprometido(item) { return !!item.data || !!item.escolhido_em; }

export default function PortalConteudo({ conteudos, lotes, token, onEventoAlterado, onEscolher, onTrocarTiktok, persona, linkDriveCliente }) {
  const [aba, setAba] = useState('roteiros');
  const [filtroFormato, setFiltroFormato] = useState('');
  const [filtroPlataforma, setFiltroPlataforma] = useState('');
  const [filtroSubnicho, setFiltroSubnicho] = useState('');
  const [filtroAssunto, setFiltroAssunto] = useState('');
  const [escolhendoId, setEscolhendoId] = useState(null);
  const [trocandoId, setTrocandoId] = useState(null);

  // Vídeos de TikTok sem data ainda são acervo interno — só aparecem
  // pro cliente quando a equipe/sistema define quando vão ao ar.
  const comRoteiro = conteudos.filter(c => {
    if (!(c.lote_id || c.roteiro_arquivo)) return false;
    if (!c.data && !grupoQuota(c)) return false;
    return true;
  });
  const formatos = useMemo(() => [...new Set(comRoteiro.map(c => c.formato).filter(Boolean))], [comRoteiro]);
  const plataformas = useMemo(() => [...new Set(comRoteiro.map(c => c.plataforma).filter(Boolean))], [comRoteiro]);
  const subnichos = useMemo(() => [...new Set(comRoteiro.map(c => c.subnicho).filter(Boolean))], [comRoteiro]);
  const assuntos = useMemo(() => [...new Set(comRoteiro.map(c => c.assunto).filter(Boolean))], [comRoteiro]);

  const filtrados = comRoteiro.filter(c =>
    (!filtroFormato || c.formato === filtroFormato) &&
    (!filtroPlataforma || c.plataforma === filtroPlataforma) &&
    (!filtroSubnicho || c.subnicho === filtroSubnicho) &&
    (!filtroAssunto || c.assunto === filtroAssunto)
  );

  // "Pra gravar" = já tem data (TikTok auto-agendado) ou já foi escolhido
  // pelo cliente — em ordem, pra saber por onde começar.
  const comprometidos = filtrados.filter(estaComprometido).sort((a, b) => {
    if (a.data && b.data) return a.data.localeCompare(b.data);
    if (a.data) return -1;
    if (b.data) return 1;
    return (a.escolhido_em || '').localeCompare(b.escolhido_em || '');
  });
  // "Disponível pra escolher" = ainda no acervo, esperando o cliente decidir.
  const disponiveis = filtrados.filter(c => !estaComprometido(c));
  // Trata como "sem leva" tanto quem realmente não tem lote_id quanto quem
  // aponta pra uma leva que não existe mais (órfão) — nunca esconder do cliente.
  const idsLotesValidos = new Set(lotes.map(l => l.id));
  const disponiveisSemLote = disponiveis.filter(c => !c.lote_id || !idsLotesValidos.has(c.lote_id));

  const ordenados = [...conteudos].sort((a, b) => (a.data || '').localeCompare(b.data || ''));

  const escolhidosMes = conteudos.filter(c => grupoQuota(c) === 'mes' && c.escolhido_em && new Date(c.escolhido_em) >= inicioMes()).length;
  const escolhidosSemana = conteudos.filter(c => grupoQuota(c) === 'semana' && c.escolhido_em && new Date(c.escolhido_em) >= inicioSemana()).length;

  // Acervo de TikTok (sem data ainda) — usado pra oferecer troca de um
  // vídeo pré-agendado por outro que o cliente prefira.
  const tiktokAcervo = conteudos.filter(c => ehTikTok(c) && !c.data);

  async function handleEscolher(conteudoId, escolher) {
    setEscolhendoId(conteudoId);
    try {
      await onEscolher(conteudoId, escolher);
    } catch (e) {
      alert('Não consegui salvar: ' + e.message);
    }
    setEscolhendoId(null);
  }

  async function handleTrocar(atualId, novoId) {
    setTrocandoId(atualId);
    try {
      await onTrocarTiktok(atualId, novoId);
    } catch (e) {
      alert('Não consegui trocar: ' + e.message);
    }
    setTrocandoId(null);
  }

  function escolhaPorItem(item) {
    const grupo = grupoQuota(item);
    if (!grupo) return null;
    const podeEscolher = grupo === 'mes' ? escolhidosMes < LIMITE_CRIATIVOS_MES : escolhidosSemana < LIMITE_INSTAGRAM_SEMANA;
    const quotaTexto = grupo === 'mes' ? `${escolhidosMes}/${LIMITE_CRIATIVOS_MES} criativos escolhidos este mês` : `${escolhidosSemana}/${LIMITE_INSTAGRAM_SEMANA} escolhidos esta semana`;
    return { grupo, podeEscolher, quotaTexto, escolhendo: escolhendoId === item.id, onEscolher: (v) => handleEscolher(item.id, v) };
  }

  function trocaPorItem(item) {
    if (!ehTikTok(item) || !item.data || item.escolhido_em || temEvento(item, 'recusado')) return null;
    return { disponiveis: tiktokAcervo, trocando: trocandoId === item.id, onTrocar: (novoId) => handleTrocar(item.id, novoId) };
  }

  return (
    <div>
      <div className="tabs-wrap" style={{ marginBottom: 16 }}>
        <button onClick={() => setAba('roteiros')} className={`tab-btn${aba === 'roteiros' ? ' active' : ''}`}>Roteiros pra gravar</button>
        <button onClick={() => setAba('calendario')} className={`tab-btn${aba === 'calendario' ? ' active' : ''}`}>Calendário de publicação</button>
        <button onClick={() => setAba('perfil')} className={`tab-btn${aba === 'perfil' ? ' active' : ''}`}>Perfil de Marca</button>
      </div>

      {aba === 'roteiros' && (
        <div>
          {linkDriveCliente && (
            <div style={{ marginBottom: 18 }}>
              <a href={linkDriveCliente} target="_blank" rel="noreferrer"
                style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'linear-gradient(120deg, var(--purple), var(--purple-rich))', color: 'white', borderRadius: 12, padding: '12px 16px', textDecoration: 'none', fontWeight: 600, fontSize: 13.5 }}>
                📁 Abrir pasta do Drive pra ver e enviar suas gravações
              </a>
              <div style={{ fontSize: 11.5, color: 'var(--text-secondary)', marginTop: 6 }}>
                Salve cada gravação na subpasta correspondente ao formato/rede social do roteiro (Criativos, TikTok, Instagram...).
              </div>
            </div>
          )}
          {(escolhidosMes > 0 || conteudos.some(c => grupoQuota(c) === 'mes') || conteudos.some(c => grupoQuota(c) === 'semana')) && (
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 16 }}>
              {conteudos.some(c => grupoQuota(c) === 'mes') && (
                <div style={{ background: 'var(--bg-secondary)', borderRadius: 20, padding: '6px 14px', fontSize: 12, fontWeight: 600, color: 'var(--purple-rich)' }}>
                  🎬 Criativos: {escolhidosMes}/{LIMITE_CRIATIVOS_MES} este mês
                </div>
              )}
              {conteudos.some(c => grupoQuota(c) === 'semana') && (
                <div style={{ background: 'var(--bg-secondary)', borderRadius: 20, padding: '6px 14px', fontSize: 12, fontWeight: 600, color: 'var(--purple-rich)' }}>
                  📷 Instagram: {escolhidosSemana}/{LIMITE_INSTAGRAM_SEMANA} esta semana
                </div>
              )}
            </div>
          )}
          {(formatos.length > 0 || plataformas.length > 0 || subnichos.length > 0 || assuntos.length > 0) && (
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 18 }}>
              {formatos.length > 0 && (
                <select value={filtroFormato} onChange={e => setFiltroFormato(e.target.value)} className={`chip-select${filtroFormato ? ' active' : ''}`}>
                  <option value=''>Formato</option>
                  {formatos.map(f => <option key={f} value={f}>{f}</option>)}
                </select>
              )}
              {plataformas.length > 0 && (
                <select value={filtroPlataforma} onChange={e => setFiltroPlataforma(e.target.value)} className={`chip-select${filtroPlataforma ? ' active' : ''}`}>
                  <option value=''>Rede social</option>
                  {plataformas.map(p => <option key={p} value={p}>{p}</option>)}
                </select>
              )}
              {subnichos.length > 0 && (
                <select value={filtroSubnicho} onChange={e => setFiltroSubnicho(e.target.value)} className={`chip-select${filtroSubnicho ? ' active' : ''}`}>
                  <option value=''>Subnicho</option>
                  {subnichos.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              )}
              {assuntos.length > 0 && (
                <select value={filtroAssunto} onChange={e => setFiltroAssunto(e.target.value)} className={`chip-select${filtroAssunto ? ' active' : ''}`}>
                  <option value=''>Assunto</option>
                  {assuntos.map(a => <option key={a} value={a}>{a}</option>)}
                </select>
              )}
            </div>
          )}

          {filtrados.length === 0 && <div className="portal-estado">Nenhum roteiro disponível ainda com esse filtro.</div>}

          {comprometidos.length > 0 && (
            <div style={{ marginBottom: 28 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                <span style={{ fontWeight: 700, fontSize: 14, color: 'var(--purple-rich)' }}>📅 Pra gravar, em ordem</span>
                <div style={{ flex: 1, height: 1, background: 'rgba(107,33,168,0.12)' }} />
              </div>
              {comprometidos.map(item => (
                <RoteiroCard key={item.id} item={item} arquivoLote={lotes.find(l => l.id === item.lote_id)?.arquivo_unico}
                  token={token} onEventoAlterado={onEventoAlterado} escolha={escolhaPorItem(item)} troca={trocaPorItem(item)} />
              ))}
            </div>
          )}

          {disponiveis.length > 0 && (
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                <span style={{ fontWeight: 700, fontSize: 14, color: 'var(--purple-rich)' }}>📦 Disponível pra escolher</span>
                <div style={{ flex: 1, height: 1, background: 'rgba(107,33,168,0.12)' }} />
              </div>
              {lotes.map(lote => {
                const itensDoLote = disponiveis.filter(c => c.lote_id === lote.id);
                if (!itensDoLote.length) return null;
                return <LoteBloco key={lote.id} lote={lote} itens={itensDoLote} token={token} onEventoAlterado={onEventoAlterado} escolhaPorItem={escolhaPorItem} />;
              })}
              {disponiveisSemLote.map(item => <RoteiroCard key={item.id} item={item} token={token} onEventoAlterado={onEventoAlterado} escolha={escolhaPorItem(item)} />)}
            </div>
          )}
        </div>
      )}

      {aba === 'calendario' && (
        ordenados.filter(c => c.data).length === 0
          ? <div className="portal-estado">Nenhum conteúdo planejado ainda.</div>
          : <CalendarioPublicacao conteudos={ordenados} />
      )}

      {aba === 'perfil' && <PortalPerfilMarca token={token} persona={persona} />}
    </div>
  );
}
